// relative
import { apiSlice } from '../../apiSlice';

export const subscriptionsApiSlice = apiSlice.injectEndpoints({
  tagTypes: ['Subscription', 'Building'],
  endpoints: (builder) => ({
    postSubscription: builder.mutation({
      query: (subscription) => ({
        url: '/JobSubscription',
        method: 'POST',
        body: { ...subscription },
      }),
      transformResponse: (response, meta) => {
        // Access the Location header
        const locationHeader = meta?.response?.headers.get('Location');
        // Return the original response and the extracted ID
        return { data: response, location: locationHeader };
      },
      invalidatesTags: ['Subscription', 'Building'],
    }),
    getSubscriptions: builder.query({
      query: () => {
        return {
          url: `/JobSubscription`,
        };
      },
      providesTags: ['Subscription', 'Building'],
    }),
    getSubscriptionById: builder.query({
      query: (args) => {
        const { id } = args;
        return {
          url: `/JobSubscription/${id}`,
        };
      },
      providesTags: ['Subscription', 'Building'],
    }),
    getJobRunHistoryById: builder.query({
      query: (args) => {
        const { id, from, to } = args;
        return {
          url: `/JobSubscription/History?orderby=Timestamp&JobSubscriptionId=eq(${id})&Timestamp=ge(${from})&Timestamp=le(${to})&top=10000`,
        };
      },
      providesTags: ['Subscription', 'Building'],
    }),
    updateSubscription: builder.mutation({
      query: ({ id, patch }) => ({
        url: `JobSubscription/${id}`,
        method: 'PUT',
        body: patch,
      }),
      invalidatesTags: ['Subscription', 'Building', 'Units'],
      transformResponse: (response, meta) => {
        // Access the Location header
        const locationHeader = meta?.response?.headers.get('Location');
        // Return the original response and the extracted ID
        return { data: response, location: locationHeader };
      },
    }),
    getSubscriptionsByAccount: builder.query({
      query: (args) => {
        const accountId = args;
        return {
          url: `/JobSubscription?orderby=JobSubscriptionId&Account.AccountId=eq(${accountId})&top=10000`,
        };
      },
      providesTags: ['Subscription', 'Building'],
    }),
    getSubscriptionsByAccountAndBuilding: builder.query({
      query: (args) => {
        const { accountId, buildingId } = args;
        return {
          url: `/JobSubscription?orderby=JobSubscriptionId&Account.AccountId=eq(${accountId})&Building.BuildingId=eq(${buildingId})&top=10000`,
        };
      },
      providesTags: ['Subscription', 'Building'],
    }),
    getSubscriptionsByBuildingId: builder.query({
      query: (args) => {
        const buildingId = args;
        return {
          url: `/JobSubscription?orderby=JobSubscriptionId&Building.BuildingId=eq(${buildingId})&top=10000`,
        };
      },
      providesTags: ['Subscription', 'Building'],
    }),
    updateManualRunRequest: builder.mutation({
      query: ({ id }) => ({
        url: `/JobSubscription/${id}/ManualRunRequest`,
        headers: { 'Content-Type': 'application/json' },
        method: 'PUT',
        body: 1,
      }),
      invalidatesTags: ['Subscription'],
    }),
    getBaselineDaysByJobSubscriptionId: builder.query({
      query: (args) => {
        const { jobSubscriptionId, timestamp } = args;
        return {
          url: `/JobSubscription/${jobSubscriptionId}/BaselineDays?orderby=Start&Start=ge(${timestamp.startDate})&End=le(${timestamp.endDate})&top=10000`,
        };
      },
      providesTags: ['Baseline'],
      keepUnusedDataFor: 60,
    }),
    getControlPeriodsByJobSubscriptionId: builder.query({
      query: (args) => {
        const { jobSubscriptionId, timestamp } = args;
        return {
          url: `/JobSubscription/${jobSubscriptionId}/ControlPeriods?orderby=Start&Start=ge(${timestamp})&top=10000`,
        };
      },
      providesTags: ['Baseline'],
      keepUnusedDataFor: 60,
    }),
    deleteJobSubscription: builder.mutation({
      query: (id) => ({
        url: `/JobSubscription/${id}`,
        method: 'DELETE',
      }),
      invalidatesTags: ['Subscription', 'Building'],
    }),
  }),
});

export const {
  usePostSubscriptionMutation,
  useGetSubscriptionsQuery,
  useGetSubscriptionByIdQuery,
  useLazyGetSubscriptionByIdQuery,
  useGetJobRunHistoryByIdQuery,
  useUpdateSubscriptionMutation,
  useGetSubscriptionsByAccountQuery,
  useGetSubscriptionsByAccountAndBuildingQuery,
  useUpdateManualRunRequestMutation,
  useGetSubscriptionsByBuildingIdQuery,
  useGetBaselineDaysByJobSubscriptionIdQuery,
  useLazyBaselineDaysByJobSubscriptionIdQuery,
  useGetControlPeriodsByJobSubscriptionIdQuery,
  useLazyControlPeriodsByJobSubscriptionIdQuery,
  useDeleteJobSubscriptionMutation,
} = subscriptionsApiSlice;
